import { styled } from '@mui/material'

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  width: ${({ theme }) => theme.spacing(42)};
  align-self: center;
`

export const NumpadRow = styled('div')`
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.palette.text.primary};
`
